import { useEffect, useState } from "react";
import style from "../../../../sass/pages/profile/profile.module.scss";
import { useTranslation } from "react-i18next";
import { getSenderDistricts } from "../../../../api/sender-districts/sender-districts";
import GreenSpinner from "../../../../components/loaders/GreenSpinner";

const SenderDistrictInput = ({ state, setState, enabled, senderTownID, initialID }) => {
    const { t } = useTranslation();
    const handleChange = (e) => {
        if (!e.target.value) {
            setState("");
            return;
        }
        setState(+e.target.value);
    };

    const [senderDistricts, setSenderDistricts] = useState(null);
    const [isPending, setIsPending] = useState(false);

    useEffect(() => {
        if (!setIsPending) {
            return false;
        }

        if (!senderTownID) {
            return;
        }
        setIsPending(true);

        (async () => {
            const districts = await getSenderDistricts(senderTownID);
            if (!districts) {
                return;
            }
            console.log(districts);
            setSenderDistricts(districts);
            setIsPending(false);
        })();
    }, [senderTownID, setIsPending]);

    useEffect(() => {
        if(!senderDistricts) {
            setState("");
            return;
        }

        const district = senderDistricts.find((district) => {
            return district.id === state;
        });

        if (district) {
            return;
        }

        for (let i in senderDistricts) {
            if(initialID && senderDistricts.find(district => district.id === initialID)) {
                    setState(+initialID);
                    return;
            }

            if (senderDistricts[i]["sender-town-id"] === senderTownID) {
                setState(+senderDistricts[i].id);
                return;
            }
        }

        setState(0);
    }, [initialID, senderDistricts, senderTownID, setState, state]);

    useEffect(() => {
        if(!senderDistricts) {
            setState("");
            return;
        }
        if(senderDistricts.length === 0) {
            setState(0);
        }
    },  [senderDistricts, setState]);
    

    return (
        <>
            {senderDistricts?.length > 0 && (
                <div className="grid grid-cols-8 xs:grid-cols-12 items-center">
                    <span className="col-span-4 text-xs text-left font-bold">
                        {t("user.inputs.district.title")}
                    </span>
                    {isPending && (
                        <GreenSpinner width="1rem" height="1rem" />
                    )}
                    {!isPending && (
                        <select
                            className={`${style.select} col-span-4 text-xs text-left font-bold`}
                            id="sender-region"
                            value={state}
                            onInput={handleChange}
                            disabled={!enabled}
                        >
                            <option value="" disabled selected hidden></option>
                            {senderDistricts?.map((option, index) => (
                                <option
                                    selected={+state === +option.value}
                                    key={index}
                                    value={+option.id}
                                >
                                    {option.name}
                                </option>
                            ))}
                        </select>
                    )}
                </div>
            )}
        </>
    );
};

export default SenderDistrictInput;
